module.exports = __webpack_public_path__ + "static/media/awaiting_parts_orange.21c6e984.svg";